import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    Stack,
    Box,
    Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    DateInput,
    Select,
    Input,
    CommonModal,
} from '../index';
import { trakrefBlue } from '../../../color_utils';
import { trakrefFontFamilyBold } from '../../../utils';
import Routes from '../../../routes';

const SystemRegistrationModal = ({
    open,
    closeModal,
    onSubmit,
    state,
    setState,
    isLoading,
}) => {
    const [registrationTypes, setRegistrationTypes] = useState([]);
    const [errors, setErrors] = useState({
        registrationType: false,
        systemId: false,
    });

    const fetchRegistrationTypes = useCallback(async () => {
        const response = await fetch(Routes.RegulatedAssetType.GetAll());
        if (response.status === 200) {
            const data = await response.json();
            setRegistrationTypes(data.map(rt => ({ label: rt.name, value: rt.id })));
        }
    }, []);

    useEffect(() => {
        if (open) {
            fetchRegistrationTypes();
        }
    }, [open, fetchRegistrationTypes]);

    const handleSubmit = () => {
        const newErrors = {
            registrationType: !state.registrationType,
            systemId: !state.systemId,
        };

        setErrors(newErrors);

        if (newErrors.registrationType || newErrors.systemId) {
            return;
        }

        onSubmit();
    };

    const handleClose = () => {
        setErrors({ registrationType: false, systemId: false });
        closeModal();
    };

    return (
        <CommonModal
            open={open}
            close={handleClose}
            header={state.editId ? "Edit System Registration" : "System Registration"}
            bottom={24}
            scroll="paper"
        >
            <Grid container pl={10} pr={10}>
                <Grid item xs={12} lg={12} mb={2} pt={2} align="center">
                    <Stack spacing={3}>
                        <Select
                            required
                            fullWidth
                            variant="standard"
                            label="Registration Type"
                            options={registrationTypes}
                            value={state.registrationType}
                            onChange={e => {
                                setErrors(prev => ({ ...prev, registrationType: false }));
                                setState({ registrationType: e.target.value });
                            }}
                            error={errors.registrationType}
                        />
                        <Input
                            required
                            fullWidth
                            variant="standard"
                            label="System ID"
                            value={state.systemId}
                            onChange={e => {
                                setErrors(prev => ({ ...prev, systemId: false }));
                                setState({ systemId: e.target.value });
                            }}
                            error={errors.systemId}
                        />
                        <DateInput
                            allowPast
                            label="Effective Date"
                            variant="standard"
                            date={state.effectiveDate}
                            onChange={new_date => setState({ effectiveDate: new_date })}
                        />
                        <DateInput
                            allowPast
                            label="End Date"
                            variant="standard"
                            date={state.endDate}
                            onChange={new_date => setState({ endDate: new_date })}
                        />
                        <Input
                            fullWidth
                            variant="standard"
                            label="Notes"
                            value={state.notes}
                            onChange={e => setState({ notes: e.target.value })}
                            multiline
                            rows={3}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={12} align="center">
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <LoadingButton
                            fullWidth
                            size="large"
                            variant="contained"
                            loading={isLoading}
                            onClick={handleSubmit}
                            sx={{
                                '& .MuiCircularProgress-root': {
                                    color: '#FFFFFF',
                                    width: '21px !important',
                                    height: '21px !important',
                                },
                            }}
                            style={{
                                backgroundColor: trakrefBlue,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: trakrefFontFamilyBold,
                                    color: isLoading ? 'transparent' : '#fff',
                                    backgroundColor: trakrefBlue,
                                    letterSpacing: '1.2px',
                                    padding: '1% 0%',
                                    fontSize: 17,
                                    fontWeight: 400,
                                }}
                            >
                                {state.editId ? 'Update Registration' : 'Add Registration'}
                            </Typography>
                        </LoadingButton>
                    </Box>
                </Grid>
            </Grid>
        </CommonModal>
    );
};

SystemRegistrationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    state: PropTypes.object.isRequired,
    setState: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default SystemRegistrationModal;
